import { render, staticRenderFns } from "./formItem.vue?vue&type=template&id=88cb15b6&scoped=true&"
import script from "./formItem.vue?vue&type=script&lang=js&"
export * from "./formItem.vue?vue&type=script&lang=js&"
import style0 from "./formItem.vue?vue&type=style&index=0&id=88cb15b6&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cb15b6",
  null
  
)

export default component.exports